import { render, staticRenderFns } from "./EdudashDatePicker.vue?vue&type=template&id=24015191&scoped=true&"
import script from "./EdudashDatePicker.vue?vue&type=script&lang=js&"
export * from "./EdudashDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./EdudashDatePicker.vue?vue&type=style&index=0&id=24015191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24015191",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
